import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  logoutContainer: {
    marginRight: 15,
    marginTop: 5,
  },
});
